<template>
  <div>
    <div
      v-show="isLoading"
      class="flex flex-row justify-end"
    >
      <div class="w-4/12">
        <vs-progress
          indeterminate
          color="primary"
        />
      </div>
    </div>
    <!-- Delays Section -->
    <div>
      <span class="font-semibold text-xl">Delays</span>
      <vs-row class="mt-5">
        <vs-col
          v-for="(item, index) of delayTimeField.delays"
          vs-w="6"
          :key="index"
          :class="[((index + 1) % 2) ? 'pr-2' : 'pl-2']"
        >
          <p class="mb-2 font-medium">
            {{ item.name }}
          </p>
          <div class="flex flex-row">
            <vs-input
              v-model="item.value"
              :disabled="item.isDisabled"
            />
            <div class="px-2 flex flex-col justify-center rounded-r-lg bg-primary">
              <span class="text-white">hours</span>
            </div>
          </div>
        </vs-col>
      </vs-row>
    </div>
    <!-- Waiting Instruction Section -->
    <div class="mt-5 p-5 border border-grey-001 rounded-lg">
      <span class="font-semibold text-xl">Waiting Instruction</span>
      <vs-row class="mt-5">
        <vs-col
          v-for="(item, index) of delayTimeField.waiting_instruction"
          vs-w="6"
          :key="index"
          :class="[((index + 1) % 2) ? 'pr-2' : 'pl-2', {'mt-5': ((index + 1) > 2)}]"
        >
          <p class="mb-2 font-medium">
            {{ item.name }}
          </p>
          <div class="flex flex-row">
            <vs-input
              v-model="item.value"
              :disabled="item.isDisabled"
            />
          </div>
        </vs-col>
      </vs-row>
    </div>
    <!-- General Section -->
    <div class="mt-5">
      <vs-row>
        <vs-col
          v-for="(item, index) of delayTimeField.data"
          vs-w="6"
          :key="index"
          :class="[((index + 1) % 2) ? 'pr-2' : 'pl-2', {'mt-5': ((index + 1) > 2)}]"
        >
          <p class="mb-2 font-medium">
            {{ item.name }}
          </p>
          <div class="flex flex-row">
            <vs-input
              v-model="item.value"
              :disabled="item.isDisabled"
              :placeholder="item.key === 'remarks' ? 'Enter Remark' : null"
            />
            <div
              v-show="item.key !== 'remarks'"
              class="px-2 flex flex-col justify-center rounded-r-lg bg-primary"
            >
              <span class="text-white">hours</span>
            </div>
          </div>
        </vs-col>
      </vs-row>
    </div>
    <!-- Total Data Section -->
    <div class="my-5">
      <div class="flex flex-row">
        <div class="card-total-hour-secondary-border" />
        <div class="card-total-hour">
          <span>Total hours</span>
          <span class="font-semibold text-secondary">{{ bargeDelayTime ? bargeDelayTime.total_hours : 0 }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BargeLineUpDelayField from '@/fixtures/barge-line-up-delay-time.json'

export default {
  props: {
    isLoading: {
      type: Boolean,
      default: () => false
    },
    bluDetail: {
      type: Object,
      default: () => null
    },
    bargeDelayTime: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      delayTimeField: BargeLineUpDelayField
    }
  },
  watch: {
    bargeDelayTime: {
      handler(val) {
        if (val) {
          this.parseData(val)
        }
      }
    },
    delayTimeField: {
      deep: true,
      handler() {
        this.onFieldChange()
      }
    }
  },
  methods: {
    parseData(data) {
      this.delayTimeField.delays.forEach(item => {
        Object.keys(data).forEach(key => {
          if (item.key === key) {
            item.value = data[key]
          }
        })
      })

      this.delayTimeField.waiting_instruction.forEach(item => {
        Object.keys(data).forEach(key => {
          if (item.key === key) {
            item.value = data[key]
          }
        })
      })

      this.delayTimeField.data.forEach(item => {
        Object.keys(data).forEach(key => {
          if (item.key === key) {
            item.value = data[key]
          }
        })
      })
    },
    onFieldChange() {
      let delayItem, waitingInstructionItem, dataItem = {}

      this.delayTimeField.delays.forEach(({ key, value }) => {
        delayItem = { ...delayItem, [key]: value }
      })
      this.delayTimeField.waiting_instruction.map(({ key, value }) => {
        waitingInstructionItem = { ...waitingInstructionItem, [key]: value }
      })
      this.delayTimeField.data.map(({ key, value }) => {
        dataItem = { ...dataItem, [key]: value }
      })

      const submittedItem = {
        ...delayItem,
        ...waitingInstructionItem,
        ...dataItem,
        barge_line_up_id: this.bluDetail ? this.bluDetail.id : null,
        filename: this.bargeDelayTime ? this.bargeDelayTime.filename : null,
        no: this.bargeDelayTime ? this.bargeDelayTime.no : null,
        total_hours: this.bargeDelayTime ? this.bargeDelayTime.total_hours : 0
      }

      this.$emit('onFieldChange', submittedItem)
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.vs-input--input {
  @apply bg-white;

  &:disabled {
    background-color: #ECEBED;
  }
}

.card-total-hour {
  @apply w-full px-3 py-4 flex flex-row items-center justify-between bg-white font-semibold text-lg rounded-tr-lg rounded-br-lg;
}

.card-total-hour-secondary-border {
  @apply w-3 bg-secondary rounded-tl-lg rounded-bl-lg;
}
</style>
